import React, { useEffect, useState } from 'react';
import { BLUE_WARNING_ICON } from '@Images';
import { UNSUPPORTED_BANK_POP_UP_THB } from '../alert-Message/constants';
import CommonButton from '../common-button/CommonButton';
import { Container, Bold } from './Style';
import { compileTemplateNewWithStyling } from '@Utils/library';
import { getContentSchemaFromContentFul } from '@Redux/actions/common';
import { SupportedBankCardProps, thbUnsupportedBankAlert } from './Interface';

export const UnSupportedBankAlertCard = (
  props: SupportedBankCardProps
): React.ReactElement<SupportedBankCardProps> => {
  const { onClose } = props;
  const [cmsData, setCMSData] = useState<thbUnsupportedBankAlert>();

  const fetchSendMoneyCMSData = async () => {
    const response = await getContentSchemaFromContentFul(
      'pageSendMoneyPaymentMethod',
      'MOBILE_SEND_MONEY_PAYMENT_METHOD'
    );
    setCMSData(response?.labels?.value?.thbUnsupportedBankAlert);
  };

  const {
    heading,
    descriptionNote,
    primaryCTA,
    descriptionListWeb,
    sameDayPayouts,
    cutoffTime,
    receivingBankFees,
    estimatedFeeRange
  } = {
    ...UNSUPPORTED_BANK_POP_UP_THB.alertPopup,
    ...cmsData?.alertPopup
  };

  useEffect(() => {
    fetchSendMoneyCMSData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const values = {
    sameDayPayouts: <Bold>{sameDayPayouts}</Bold>,
    cutoffTime: <Bold>{cutoffTime}</Bold>,
    receivingBankFees: <Bold>{receivingBankFees}</Bold>,
    estimatedFeeRange: <Bold>{estimatedFeeRange}</Bold>
  };
  return (
    <Container>
      <div className="image-container">
        <img
          width={64}
          height={64}
          src={BLUE_WARNING_ICON}
          alt="unsupported-bank-warning"
          onClick={() => {
            onClose(false);
          }}
        />
        <div className="heading">{heading}</div>
      </div>
      <div className="sub-heading">{descriptionNote}</div>
      <div className="description">
        {
          <ul className="list">
            {descriptionListWeb?.map((item, index) => (
              <li className="message-info" key={index}>
                {compileTemplateNewWithStyling(item, values)}
              </li>
            ))}
          </ul>
        }
      </div>
      <div className="btn-wrapper">
        <CommonButton text={primaryCTA} onClick={() => onClose(false)} width={410} />
      </div>
    </Container>
  );
};
